import * as React from "react";
import GeoBanner from "./src/components/GeoBanner";
import resolvePageLanguage from "./src/utils/resolvePageLanguage";

export const onClientEntry = (_args, pluginOptions) => {
    if (!pluginOptions.disableStyles) {
        require("./src/components/GeoBanner.css");
    }
};

export const wrapPageElement = ({ element, props }, pluginOptions) => {
    if (pluginOptions.disableAutoInject) return element;

    const pathname = props.location ? props.location.pathname : "";
    const pageLanguage = resolvePageLanguage(
        pathname,
        pluginOptions.defaultLanguage,
        pluginOptions.secondaryLanguage
    );

    return (
        <>
            <GeoBanner
                cookieName={pluginOptions.cookieName}
                drupalBaseUrl={pluginOptions.drupalBaseUrl}
                configUrl={pluginOptions.configUrl}
                defaultLanguage={pluginOptions.defaultLanguage}
                pageLanguage={pageLanguage}
                apiKey={pluginOptions.apiKey}
                injectSelector={pluginOptions.injectSelector}
                injectPosition={pluginOptions.injectPosition}
                locationKey={
                    props.location
                        ? `${props.location.pathname}${props.location.search}`
                        : undefined
                }
            />
            {element}
        </>
    );
};